module.exports = __webpack_public_path__ + "img/logo3.08538d79.png";